import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFirstPage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={10}
    fill="none"
    viewBox="0 0 10 10"
    {...props}
  >
    <path
      fill="#999"
      d="M.833 10a.806.806 0 0 1-.593-.24.806.806 0 0 1-.24-.593V.833C0 .597.08.4.24.24.4.08.597 0 .833 0s.434.08.594.24c.16.16.24.357.24.593v8.334c0 .236-.08.434-.24.593a.806.806 0 0 1-.594.24M6.5 5l3.25 3.25a.79.79 0 0 1 .23.583.79.79 0 0 1-.23.584.79.79 0 0 1-.583.229.79.79 0 0 1-.584-.23L4.75 5.584a.731.731 0 0 1-.177-.27A.922.922 0 0 1 4.52 5c0-.111.017-.215.052-.312a.731.731 0 0 1 .177-.271L8.583.583a.79.79 0 0 1 .584-.229.79.79 0 0 1 .583.23.79.79 0 0 1 .23.583.79.79 0 0 1-.23.583z"
    />
  </svg>
);
export default SvgFirstPage;
